/**
 * 菜单叶子导航（domain · 菜单领域服务）
 * ------------------------------------------------------------
 * RailNav（左栏菜单树）与 AppView（应用中心大页）共用的叶子跳转口径：
 * route=页面路由 / app=应用工作台 / stub=建设中占位页；每个叶子在
 * 中间区域各成一页，跳转前登记页签标题（fullPath 与 router.afterEach
 * 的 openTab 键一致；stub 经 router.resolve 生成编码后的 fullPath，
 * 保证登记键与导航键完全相同）。
 */
import type { Router } from 'vue-router'
import { reactive } from 'vue'
import type { MenuLeaf } from '@/data/api/repository'
import { setTabTitle } from '@/domain/worktabs'

/** Compatibility at the menu boundary for persisted pre-rename procurement entries. */
export function menuRoute(route:string){return route.replace(/^\/proc(?=\?|$)/,'/procurement')}

/** 从菜单进入过的页面路径（不含 query）：壳层据此把该页当作菜单体系页，
 *  点击菜单后左栏必须常驻——不依赖菜单接口返回时机，接口失败时也不会丢左栏 */
export const menuNavPaths = reactive(new Set<string>())

export function openLeafNav(router: Router, l: MenuLeaf) {
  let fullPath: string
  let title: string
  if (l.route) {
    fullPath = menuRoute(l.route)
    title = l.name
  } else if (l.app) {
    fullPath = '/apps/' + encodeURIComponent(l.app)
    title = l.name
  } else {
    fullPath = router.resolve({ path: '/building', query: { name: l.name } }).fullPath
    title = l.name + ' · 建设中'
  }
  menuNavPaths.add(fullPath.split('?')[0])
  setTabTitle(fullPath, title)
  void router.push(fullPath)
}
